import React from 'react'
import styled from 'styled-components'
import media from '@Styles/media'
import messages from '@Modules/hubs/main/messages'
import CopyLink from './CopyLink'
import { IntlShape } from 'react-intl/src/types'
import { HubText } from 'src/common/rtl/HubWidgets'

type Props = {
  handleCopyMemberId: () => void
  intl: IntlShape
  memberId: string
}

const MemberId: React.FC<Props> = (props: Props) => {
  const { handleCopyMemberId, intl, memberId } = props

  return (
    <Container>
      <HubText>{`${intl.formatMessage(messages.memberId)} `}</HubText>&nbsp;
      <HubText>{memberId}</HubText>
      <CopyWrapper onClick={handleCopyMemberId}>
        <CopyLink valueToCopy={memberId} intl={intl} />
      </CopyWrapper>
    </Container>
  )
}

const CopyWrapper = styled.div`
  position: relative;
  margin-left: 6px;
  opacity: 0;
  transition: opacity 150ms ease;
  cursor: pointer;

  ${media.smallerThanLargeScreen`
    opacity: 1;
  `};
`

const Container = styled.div`
  padding: 6px 0;
  display: flex;

  word-break: break-word;
  color: inherit;
  display: flex;
  font-size: ${({ theme }) => theme.fontSizes.fontSizeSmall};

  ${media.smallScreen`
      font-size: ${({ theme }: any) => theme.fontSizes.fontSizeSmaller};
    `};

  &:hover ${CopyWrapper} {
    opacity: 1;
  }
`
export default MemberId
